import styled from "@emotion/styled";
import { MenuItem } from "@mui/material";

export const ExportFileMenuItem = styled(MenuItem)({
	width: "220px",
	height: "36px"
});
